import type { CasinoSecondaryNavigation, Top } from '@ps/web-martech-cms-types';
import type { CasinoSecondaryNavigationBlock } from '@ps/web-martech-cms-types/Top';
import classNames from 'clsx';
import React from 'react';

import { useCMSReference } from '@swf/cms';

import styles from '../../styles/styles.scss';

import TopBodyItem from './TopBodyItem';

const CMSTop: React.FC<Top> = ({ body }) => {
  const casinoSecondaryNavigationBlock = body.find(
    (item) => (item as CasinoSecondaryNavigationBlock).casino_secondary_navigation
  );
  const casinoSecondaryNavigationReference = (
    casinoSecondaryNavigationBlock as CasinoSecondaryNavigationBlock
  )?.casino_secondary_navigation.reference[0];

  const casinoSecondaryNavigation = useCMSReference<CasinoSecondaryNavigation>(
    casinoSecondaryNavigationReference
  );

  return (
    <div
      id="sub-nav-container"
      className={classNames(styles.topContainer, {
        [styles.sticky]: casinoSecondaryNavigation?.sticky
      })}
    >
      {body.map((item, index) => (
        <TopBodyItem key={index} {...item} />
      ))}
    </div>
  );
};

export default CMSTop;
